export const Features = props => {
  return (
    <div id='features' className='text-center py-5'>
      <div className='container'>
        <div className='col-md-12 section-title'>
          <h2>Features</h2>
        </div>
        <div className='row'>
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.title}-${i}`} className='col-xs-6 col-md-3'>
                  {' '}
                  {typeof d.icon === 'string' ? (
                    <i className={d.icon}></i>
                  ) : (
                    <i className="feature-custom fa">
                    {d.icon}
                    </i>
                  )}
                  <h3>{d.title}</h3>
                  <p>{d.text}</p>
                </div>
              ))
            : 'Loading...'}
        </div>
      </div>
    </div>
  )
}
